// extracted by mini-css-extract-plugin
export default {"aiImageDisclosure":"FUrgh","label":"Tzu9Y","expandedMessage":"d_v0u","visuallyHidden":"K6edW","expanded":"ofEt9"};